import PropTypes from "prop-types";
import { Badge, Button, Progress } from "reactstrap";
import {
  getWorkerInitials,
  labelDbsType,
  labelWorkForce,
} from "./workerAssignmentHelpers";

function WorkerCandidateCard({
  candidate,
  assignedDatesCount,
  onAssign,
  disabled,
}) {
  const { worker, score, overlappingDates } = candidate;

  return (
    <div className="br-wa-candidate-card br-wa-candidate-card--match">
      <div className="br-wa-candidate-card__header">
        <div className="br-wa-candidate-card__avatar" aria-hidden="true">
          {getWorkerInitials(worker.fullName)}
        </div>
        <div className="br-wa-candidate-card__identity">
          <div className="br-wa-candidate-card__name">{worker.fullName}</div>
          <div className="br-wa-candidate-card__meta">
            {worker.workerId}
            {worker.locationLabel ? ` · ${worker.locationLabel}` : ""}
          </div>
        </div>
        <div className="br-wa-candidate-card__score">
          <span className="br-wa-candidate-card__score-value">{score}</span>
          <span className="br-wa-candidate-card__score-label">match</span>
        </div>
      </div>

      <p className="br-wa-candidate-card__summary">{worker.summary}</p>

      <div className="br-wa-candidate-card__chips">
        <Badge className="bg-light text-dark border">
          {worker.experienceLevel || "Experience n/a"}
        </Badge>
        <Badge className="bg-light text-dark border">
          {Number(worker.distanceKm || 0).toFixed(1)} km
        </Badge>
        <Badge className="bg-light text-dark border">
          ★ {Number(worker.rating || 0).toFixed(1)}
        </Badge>
        {worker.dbsType ? (
          <Badge className="bg-info">
            {labelDbsType(worker.dbsType)}
            {worker.workForce ? ` · ${labelWorkForce(worker.workForce)}` : ""}
          </Badge>
        ) : null}
        <Badge className="bg-success">Eligible</Badge>
      </div>

      {(worker.certSlugs || []).length > 0 && (
        <div className="br-wa-candidate-card__certs">
          {(worker.certSlugs || []).slice(0, 4).map((slug) => (
            <span key={slug} className="br-wa-cert-pill">
              {slug}
            </span>
          ))}
          {(worker.certSlugs || []).length > 4 ? (
            <span className="br-wa-cert-pill br-wa-cert-pill--more">
              +{(worker.certSlugs || []).length - 4}
            </span>
          ) : null}
        </div>
      )}

      <div className="br-wa-candidate-card__availability">
        <span className="text-muted small">
          Available on {overlappingDates.length} shift date
          {overlappingDates.length !== 1 ? "s" : ""}
        </span>
        {assignedDatesCount > 0 ? (
          <Badge className="bg-primary">
            Assigned on {assignedDatesCount} date
            {assignedDatesCount !== 1 ? "s" : ""}
          </Badge>
        ) : null}
      </div>

      <Progress
        value={score}
        className="br-wa-candidate-card__progress"
        color="primary"
      />

      <div className="br-wa-candidate-card__actions">
        <Button
          color="primary"
          size="sm"
          disabled={disabled}
          onClick={() => onAssign(worker)}
        >
          {assignedDatesCount > 0 ? "Edit dates" : "Assign to dates"}
        </Button>
      </div>
    </div>
  );
}

WorkerCandidateCard.propTypes = {
  candidate: PropTypes.shape({
    worker: PropTypes.object.isRequired,
    score: PropTypes.number.isRequired,
    overlappingDates: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  assignedDatesCount: PropTypes.number,
  onAssign: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

WorkerCandidateCard.defaultProps = {
  assignedDatesCount: 0,
  disabled: false,
};

export default WorkerCandidateCard;
